<mat-form-field appearance="outline" class="phone-form-field">
  <mat-label>{{ label }}</mat-label>
  <div class="phone-input-container">
    <div class="flag-display">
      <img *ngIf="selectedCountry" [src]="getCountryFlagUrl(selectedCountry.countryCode)">
      <span *ngIf="!selectedCountry">🌍</span>
    </div>
    <input
      #phoneInput
      matInput
      type="tel"
      class="phone-input"
      [placeholder]="placeholder"
      [(ngModel)]="displayValue"
      [disabled]="disabled"
      (ngModelChange)="onPhoneNumberChange($event)"
      (blur)="onBlur()"
    />
  </div>
  <mat-hint *ngIf="hint">{{ hint }}</mat-hint>
</mat-form-field>